<p class="font-bold line-height-2" i18n>Let's define the Short Message Service Parameters.</p>

<div>
  <rs-error-message *ngIf="errorFound" class="mb-3" [message]="errorMessage" />
  <p-table
    [value]="profileValues.smsParameters"
    [(selection)]="selectedParameters"
    dataKey="id"
    styleClass="p-datatable-striped p-datatable-gridlines"
    showGridlines="true"
    stripedRows="true"
  >
    <ng-template pTemplate="caption">
      <div class="flex align-items-center gap-2">
        <p-button
          i18n-label
          label="Add"
          icon="pi pi-plus-circle"
          size="small"
          variant="outlined"
          (onClick)="addParameter()"
          [disabled]="profileValues.smsParameters.length >= 5"
        ></p-button>
        <p-button
          i18n-label
          label="Delete"
          icon="pi pi-trash"
          size="small"
          variant="outlined"
          severity="danger"
          (onClick)="deleteParameters()"
          [disabled]="!selectedParameters || !selectedParameters.length"
        ></p-button>
      </div>
    </ng-template>
    <ng-template pTemplate="colgroup">
      <colgroup>
        <col style="width: 3rem" />
        <col style="width: 3rem" />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
        <col />
      </colgroup>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <th i18n>#</th>
        <th>
          <div i18n>Name</div>
          <div class="font-medium" i18n>(e.g., SMSC)</div>
        </th>
        <th i18n>Parameter Indicators</th>
        <th>
          <div i18n>Destination Address</div>
          <div class="font-medium" i18n>(e.g., short code)</div>
        </th>
        <th>
          <span i18n>Service Center Address</span>
          <span class="font-medium" i18n>(e.g., +13015558190)</span>
        </th>
        <th>
          <span i18n>Protocol Identifier</span>
          <span class="font-medium" i18n>(default '00')</span>
        </th>
        <th i18n>Data Coding Scheme</th>
        <th i18n>Validity Period</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-parameter let-rowIndex="rowIndex">
      <tr>
        <td style="text-align: center">
          <p-tableCheckbox [value]="parameter"></p-tableCheckbox>
        </td>
        <td style="text-align: center">{{ rowIndex + 1 }}</td>
        <td>
          <input
            (input)="handleFormEvents()"
            [(ngModel)]="parameter.name"
            class="console-text maximize-inputs"
            maxlength="10"
            type="text"
            pInputText
          />
        </td>
        <td>
          <p-multiSelect
            styleClass="maximize-inputs"
            [options]="parameterIndicatorsOptions"
            [(ngModel)]="parameter.parameterIndicators"
            optionLabel="label"
            [filter]="false"
            [showHeader]="true"
            appendTo="body"
            [maxSelectedLabels]="0"
            i18n-selectedItemsLabel
            [selectedItemsLabel]="selectedItemsLabel"
            (onChange)="handleFormEvents()"
          ></p-multiSelect>
        </td>
        <td>
          <input
            *ngIf="checkForIndicator(parameter, 1)"
            (input)="handleFormEvents()"
            [(ngModel)]="parameter.destinationAddress"
            class="console-text maximize-inputs"
            maxlength="12"
            type="text"
            pInputText
          />
        </td>
        <td>
          <input
            *ngIf="checkForIndicator(parameter, 2)"
            class="maximize-inputs"
            type="text"
            pInputText
            [(ngModel)]="parameter.serviceCenterAddress"
            (input)="handleFormEvents()"
            [maxlength]="serviceCenterAddressMaxLength"
            rsPhoneNumberInput
          />
        </td>
        <td>
          <input
            *ngIf="checkForIndicator(parameter, 3)"
            pInputText
            rsHexOnlyInput
            class="maximize-inputs console-text"
            [maxlength]="2"
            [(ngModel)]="parameter.protocolIdentifier"
            (input)="handleFormEvents()"
          />
        </td>
        <td>
          <p-select
            *ngIf="checkForIndicator(parameter, 4)"
            styleClass="maximize-inputs"
            [options]="dataCodingSchemeOptions"
            [(ngModel)]="parameter.dataCodingScheme"
            dataKey="value"
            optionLabel="label"
            i18n-placeholder
            placeholder="Please Select:"
            appendTo="body"
            (onChange)="handleFormEvents()"
          ></p-select>
        </td>
        <td>
          <p-select
            *ngIf="checkForIndicator(parameter, 5)"
            styleClass="maximize-inputs"
            [options]="validityPeriodOptions"
            [(ngModel)]="parameter.validityPeriod"
            dataKey="value"
            optionLabel="label"
            i18n-placeholder
            placeholder="Please Select:"
            appendTo="body"
            (onChange)="handleFormEvents()"
          ></p-select>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9" i18n>No parameters defined.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
